import script from "./DraftCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./DraftCollection.vue?vue&type=script&setup=true&lang=js"

import "./DraftCollection.vue?vue&type=style&index=0&id=36b0e224&scoped=true&lang=scss"
script.__scopeId = "data-v-36b0e224"

export default script